/**
 * Central registry of all known customer configuration keys and their value shapes.
 * To add a new config, add a single entry here — the API and hook infer types automatically.
 * Each value type should exactly match `response.data.value`.
 *
 * Example:
 *   export enum CustomerConfigKey {
 *     PLATFORM_NEW_FEATURE = 'platform.new-feature',
 *   }
 *
 *   [CustomerConfigKey.PLATFORM_NEW_FEATURE]: { threshold: number; rollout: boolean }
 */

export type SupportContact = {
  phone?: string
  email?: string
}

export enum CustomerConfigKey {
  EMPLOYEE_EXPERIENCE__ENABLE_SHOPPING_EXPERIENCE = 'employee-experience.enable-shopping-experience',
  EMPLOYEE_EXPERIENCE__SUPPORT_CONTACT = 'employee-experience.support-contact',
  FEATURE__PROVIDER_LOOKUP_ENABLED = 'feature.provider-lookup.enabled',
}

export type CustomerConfigMap = {
  [CustomerConfigKey.EMPLOYEE_EXPERIENCE__ENABLE_SHOPPING_EXPERIENCE]: boolean
  [CustomerConfigKey.EMPLOYEE_EXPERIENCE__SUPPORT_CONTACT]: SupportContact
  [CustomerConfigKey.FEATURE__PROVIDER_LOOKUP_ENABLED]: boolean
}

export type CustomerConfigValue<K extends keyof CustomerConfigMap> = CustomerConfigMap[K]
